import { render, staticRenderFns } from "./CmsMenuSettingForm.vue?vue&type=template&id=68513e01&"
import script from "./CmsMenuSettingForm.vue?vue&type=script&lang=js&"
export * from "./CmsMenuSettingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports